var React = require('react');

function CheckCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M21.875 10.9607V11.8807C21.8738 14.0371 21.1755 16.1354 19.8843 17.8625C18.5932 19.5897 16.7783 20.8532 14.7104 21.4646C12.6424 22.076 10.4323 22.0026 8.40947 21.2553C6.38668 20.508 4.65965 19.1268 3.48596 17.3178C2.31227 15.5088 1.75479 13.3688 1.89668 11.217C2.03856 9.06529 2.87221 7.01705 4.27328 5.3778C5.67435 3.73854 7.56779 2.59611 9.67119 2.12087C11.7746 1.64563 13.9753 1.86306 15.945 2.74072","stroke":"#008E67","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M21.875 3.88086L11.875 13.8909L8.875 10.8909","stroke":"#008E67","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CheckCircle.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CheckCircle;

CheckCircle.default = CheckCircle;
